import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var wait = function wait() {
  var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
  return new Promise(function (resolve) {
    setTimeout(resolve, interval);
  });
};
export function poll(_x, _x2, _x3) {
  return _poll.apply(this, arguments);
}
function _poll() {
  _poll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fn, needContinue, interval) {
    var timeout,
      result,
      currentTimeout,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          timeout = _args.length > 3 && _args[3] !== undefined ? _args[3] : 60000;
          _context.next = 3;
          return fn();
        case 3:
          result = _context.sent;
          currentTimeout = timeout - interval;
          if (!(!needContinue(result) || currentTimeout <= 0)) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", result);
        case 7:
          _context.next = 9;
          return wait(interval);
        case 9:
          return _context.abrupt("return", poll(fn, needContinue, interval, currentTimeout));
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _poll.apply(this, arguments);
}